// ----------------------------------------------------------------------
// <copyright file="Izenda.DashStyle.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------


/**
 * Border Settings component
 */
!(function () {
  var React = require('react');
  var classnames = require('classnames');
  var dashStyles = require('logic/data/Izenda.UIConstants').dashStyles;

  var DashStyle = React.createClass({

    propTypes: {
      onChange: React.PropTypes.func,
      dashStyle: React.PropTypes.string,
      disabled: React.PropTypes.bool
    },

    getInitialState: function () {
      return {
        dashStyle: this.props.dashStyle
      };
    },

    getDefaultProps: function () {
      return {
        dashStyle: 'dotted'
      };
    },

    onClick: function(value) {
      this.setState({
        dashStyle: value
      });

      this.props.onChange && this.props.onChange(value);
    },

    componentWillReceiveProps: function(nextProps) {
      this.setState({
        dashStyle: nextProps.dashStyle
      });
    },

    render: function() {
      var state = this.state;

      var listStyles = dashStyles.map(function(item) {
        var classes = classnames('line-style', {
          'selected' : item === state.dashStyle
        });

        return (
          <div className={classes} onClick={this.onClick.bind(this, item)} key={item}>
            <div className={item}></div>
          </div>
        );
      }.bind(this));

      var classes = classnames('dash-style', this.props.className, {
        'disabled-elm': this.props.disabled
      });

      return (
        <div className={classes}>
          {listStyles}
        </div>
      );
    }

  });
  module.exports = DashStyle;
}());



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.DashStyle.jsx